import { useEffect } from "react";

// Injects a <script type="application/ld+json"> into <head>, keyed by id.
export const useJsonLd = (id, data) => {
  const serialized = data ? JSON.stringify(data) : null;
  useEffect(() => {
    const existing = document.getElementById(id);
    if (existing) existing.remove();
    if (!serialized) return undefined;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    el.text = serialized;
    document.head.appendChild(el);
    return () => {
      const cur = document.getElementById(id);
      if (cur) cur.remove();
    };
  }, [id, serialized]);
};
